export enum WebSocketMessageType {
    TaskProgression = 'TaskProgression',
}
